import { configureStore } from '@reduxjs/toolkit';

import { stateReducer } from './state';

export const store = configureStore({
  reducer: {
    appState: stateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
